<template>
    <div class="envelope">
        <van-nav-bar left-arrow title="规则介绍" @click-left="onClickLeft" />
        <div class="main">
            <div class="head">
                <div><img src="@/assets/envelope/file.png" alt="file"></div>
                <h3>- - 关于红包提现、抵扣说明 - -</h3>
            </div>
            <div class="panel">
                <div class="content">
                    <div class="main-content">
                        <h4>尊敬的<span>销巴生活用户</span></h4>
                        <div class="text">
                            <h5>「关于红包提现说明」</h5>
                            <p>1、当您的积分余额<span>小于等于5000</span>并且红包余额<span>小于100</span>时，您可以提现任意金额的红包，共有<span>20次</span>提现次数；</p>
                            <p>2、当您的积分余额大于5000时，必须满足以下两个条件方可提现；</p>
                            <p>a、您的红包余额必须大于等于100；</p>
                            <p>b、提现金额必须为100的整数倍（比如100、200、500等）；</p>
                            <p>温馨提示：无论红包余额是多少，提现次数均为每天一次 ；且最低提现红包金额为1。</p>
                            <h5>「关于红包抵扣说明」</h5>
                            <p>1、当您的积分余额小于等于5000时，您的红包可在单笔消费中<span>直接进行抵扣</span>；</p>
                            <p>2、当您的积分余额大于5000时，红包余额需大于100方可进行抵扣；</p>
                            <p>温馨提示：单笔消费最多允许抵扣消费金额的50%。</p>
                        </div>
                    </div>
                    <div class="name">
                        <img src="@/assets/envelope/logo.png" alt="logo">
                        <span>销巴生活</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    methods: {
        //返回
        onClickLeft() {
            this.params("", "", "goBack");
        },
    },
};
</script>
<style lang="less" scoped>
.envelope {
    padding-top: calc(var(--sizeScale2) * 44px);
    font-size: calc(var(--sizeScale2) * 14px);
    line-height: calc(var(--sizeScale2) * 20px);
    color: #333;
    .main{
        min-height: calc(100vh - calc(var(--sizeScale2) * 88px));
        background-image: url('../../assets/envelope/bg1.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-origin:content-box;
        background-clip:content-box;
        .head{
            div{
                text-align: center;
                padding: 23px 0 14px 0;
                img{
                    width: 23px;
                    height: 26px;
                }
            }
            h3{
                font-size: 18px;
                line-height: 25px;
                font-weight: 600;
                color: #fff;
                text-align: center;
                margin-top: 0;
            }
        }
        .panel{
            width: 95%;
            margin: 0 auto;
            height: calc(var(--sizeScale2) * 610px);
            background: url('../../assets/envelope/bg2.png') no-repeat center;
            background-size: 100% 100%;
            margin-top: 15px;
            .content{
                padding: calc(var(--sizeScale2) * 30px) calc(var(--sizeScale2) * 35px);
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 100%;
                box-sizing: border-box;
                h4,p{
                    span{
                        color: #FF6B06;
                    }
                }
                h4{
                    font-size: calc(var(--sizeScale2) * 16px);
                    line-height: calc(var(--sizeScale2) * 24px);
                    font-weight: 500;
                    margin-bottom: calc(var(--sizeScale2) * 10px);
                }
                h5{
                    font-size: calc(var(--sizeScale2) * 14px);
                    margin: 0;
                }
                .text{
                    font-size: calc(var(--sizeScale2) * 14px);
                    line-height: calc(var(--sizeScale2) * 22px);
                    letter-spacing: 0.4px;
                }
                .name{
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    margin-top: calc(var(--sizeScale2) * 26px);
                    img{
                        width: calc(var(--sizeScale2) * 25px);
                        height: calc(var(--sizeScale2) * 25px);
                        margin-right: calc(var(--sizeScale2) * 6px);
                    }
                    span{
                        font-size: calc(var(--sizeScale2) * 15px);
                        line-height: calc(var(--sizeScale2) * 21px);
                        letter-spacing: 0.64px;
                        font-weight: 600;
                    }
                }
            }
        }
    }
    /deep/ .van-nav-bar .van-icon{
        color: #333;
    }
}
</style>